export default __webpack_public_path__ + "static/media/chef-video.d000d606.mp4";